const LangChangePassword = {
	"changePassword._title": ["CHANGE PASSWORD", "ĐỔI MẬT KHẨU"],
	"changePassword.form.label._currentPassword": [
		"Current Password",
		"Mật khẩu hiện tại",
	],
	"changePassword.form.label._newPassword": ["New Password", "Mật khẩu mới"],
	"changePassword.form.label._confirmNewPassword": [
		"Confirm New Password",
		"Nhập lại mật khẩu mới",
	],
}

export default LangChangePassword
